export default {
  'questionModal.title': '주문 문의',
  'questionModal.orderInfo': '주문 정보',
  'questionModal.productInfo': '상품 정보',
  'questionModal.messages': '메시지',
  'questionModal.sendMessage': '메시지 전송',
  'questionModal.messageSent': '메시지가 전송되었습니다.',
  'questionModal.messageFailed': '메시지 전송에 실패했습니다.',
  'questionModal.pleaseEnterMessage': '메시지를 입력하세요.',
  'questionModal.incompleteOrderInfo': '주문 정보가 불완전합니다. 주문 ID와 사용자 ID가 필요합니다.',
  'questionModal.loadingInquiry': '문의를 불러오는 중...',
  'questionModal.failedToLoadInquiry': '문의를 불러올 수 없습니다.',
  'questionModal.noInquiryFound': '문의를 찾을 수 없습니다.',
  'questionModal.admin': '관리자',
  'questionModal.user': '사용자',
  'questionModal.invalidTime': 'Invalid Time',
  'questionModal.orderColumns.applicationType': '신청구분',
  'questionModal.orderColumns.willShip': '출고여부',
  'questionModal.orderColumns.deliveryCenter': '배송센터/운송방식',
  'questionModal.orderColumns.receiver': '수취인',
  'questionModal.orderColumns.tracking': '트래킹수/입고수',
  'questionModal.orderColumns.rackNo': '랙번호',
  'questionModal.orderColumns.status': '입고상태/진행상태',
  'questionModal.orderColumns.date': '일자',
  'questionModal.productColumns.no': '번호',
  'questionModal.productColumns.image': '이미지',
  'questionModal.productColumns.name': '상품명',
  'questionModal.productColumns.code': '코드',
  'questionModal.productColumns.trackingNo': '트래킹번호',
  'questionModal.productColumns.orderNo': '주문번호',
  'questionModal.productColumns.color': '색상',
  'questionModal.productColumns.size': '사이즈',
  'questionModal.productColumns.quantity': '수량',
  'questionModal.productColumns.price': '가격',
  'questionModal.productColumns.rackNo': '랙번호',
  'questionModal.productColumns.warehouseDate': '입고상태',
  'questionModal.close': '닫기',
  'questionModal.send': '전송',
  'questionModal.attachImage': '이미지 첨부',
  'questionModal.attachFile': '파일 첨부',
  'questionModal.filesAdded': '{count}개 파일이 추가되었습니다. 메시지와 함께 전송됩니다.',
  'questionModal.preview': '미리보기',
  'questionModal.loading': '로딩 중...',
  'questionModal.editor': '에디터',
  'questionModal.text': '텍스트',
  'questionModal.enterText': '텍스트를 입력하세요',
  'questionModal.inquiryCreatedAndMessageSent': '문의가 생성되고 메시지가 전송되었습니다.',
  'questionModal.inquiryId': '문의 ID',
  'questionModal.userIdNotFound': '주문에서 사용자 ID를 찾을 수 없습니다.',
  'questionModal.inquiryIdNotFound': '문의 ID를 찾을 수 없습니다.',
  'questionModal.failedToLoadInquiryList': '문의 목록을 불러올 수 없습니다.',
  'questionModal.failedToCreateInquiry': '문의 생성에 실패했습니다.',
  'questionModal.invalidOrderIdFormat': '주문 ID 형식이 올바르지 않습니다.',
  'questionModal.orderIdNotFound': '주문 ID를 찾을 수 없습니다. 주문 상세 정보를 다시 불러와주세요.',
  'questionModal.failedToLoadOrderInfo': '주문 정보를 불러올 수 없습니다.',
  'questionModal.messageRead': '읽음',
  'questionModal.inventoryInquiry': '재고문의',
  'questionModal.inventoryInquiryTitle': '재고문의 - {orderNo}',
  'questionModal.stockProductInfo': '재고 상품 정보',
  'questionModal.stockColumns.stockNo': '재고번호',
  'questionModal.stockColumns.center': '센터',
  'questionModal.stockColumns.productImage': '상품이미지',
  'questionModal.stockColumns.mailbox': '사서함',
  'questionModal.stockColumns.memberName': '회원명',
  'questionModal.stockColumns.customsClearance': '통관품목',
  'questionModal.stockColumns.productName': '상품명',
  'questionModal.stockColumns.trackingNo': '트래킹번호',
  'questionModal.stockColumns.color': '색상',
  'questionModal.stockColumns.size': '사이즈',
  'questionModal.stockColumns.quantityPrice': '수량*단가',
  'questionModal.stockColumns.total': '합계',
  'questionModal.stockColumns.rackNo': '랙번호',
  'questionModal.stockColumns.previousRackNo': '이전 랙번호',
  'questionModal.stockColumns.stockStatus': '재고상태',
  'questionModal.stockColumns.productStatus': '상품상태',
  'questionModal.stockColumns.registrationDate': '등록일',
  'questionModal.stockColumns.modificationDate': '수정일',
  'questionModal.edit': '수정',
  'questionModal.delete': '삭제',
  'questionModal.html': 'HTML',
  'questionModal.messagePlaceholder': '메시지를 입력하세요...',
  'questionModal.htmlPlaceholder': 'HTML 코드를 입력하세요',
  'questionModal.sendButton': '보내기',
  'questionModal.noMessagesYet': '아직 메시지가 없습니다. 첫 메시지를 보내주세요.',
  'questionModal.inquiryNotCreatedYet': '문의가 아직 생성되지 않았습니다. 첫 메시지를 보내면 문의가 생성됩니다.',
  'questionModal.mock.deliveryAgent': '배송대행',
  'questionModal.mock.designatedDelivery': '지정배송',
  'questionModal.mock.weihai': '위해',
  'questionModal.mock.air': '항공',
  'questionModal.mock.receiver': '최한홍',
  'questionModal.mock.warehouseComplete': '입고완료',
  'questionModal.mock.warehouseReceived': '오유입고',
  'questionModal.mock.doorbell': '【도어벨】',
  'questionModal.notAssignedResponder': '이 문의의 담당자가 아닙니다.',
  'questionModal.translate': '번역',
  'questionModal.showOriginal': '원문 보기',
  'questionModal.translateFailed': '메시지 번역에 실패했습니다.',
  'questionModal.translateEmpty': '번역할 텍스트가 없습니다.',
  'questionModal.newMessages': '새 메시지',
  'questionModal.editingMessage': '편집 중',
};

